import React, { Component, Fragment } from 'react';
import uniqBy from 'lodash/uniqBy';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import QuestLeaderboardButton from 'containers/QuestLeaderboardModal/QuestLeaderboardButton';
import withSounds from 'containers/withSounds';
import ImageFadeComponent from 'components/ImageFadeComponent';
import TextButton from 'components/TextButton';
import CloseIcon from 'resources/cancel-circle.svg';
import PurpleW from 'resources/PurpleW.png';
import WStoreGems from '../../WStoreGems';
import {
  getCategoryLogo,
  getLocationImage,
  getQuestStockCount,
  isQuestActive
} from '../../WStoreUtils';
import WStoreConfirmation from '../WStoreConfirmation';
import ExitButtonIcon from '../assets/Button-CloseModal-Red.png';
import './WStoreQuestModal.css';

const BtnWithSounds = withSounds({ mouseEnterSound: true })(Button);

const READ_TITLE_TEXT_LIMIT = 45;
const READ_TITLE_TEXT_TRIM = READ_TITLE_TEXT_LIMIT - 15; // Make room for READ MORE text

class WStoreQuestModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      closeConfirmation: false
    };

    this.toggleOverlay = this.toggleOverlay.bind(this);
    this.closeConfirmationPage = this.closeConfirmationPage.bind(this);
  }

  toggleOverlay() {
    this.setState({
      showOverlay: !this.state.showOverlay
    });
  }

  closeConfirmationPage() {
    this.setState({ closeConfirmation: true });
  }

  renderItemImage() {
    const { selectedItem } = this.props;
    const questAwardData = selectedItem.prizeData.questAwardData;
    let prizes = questAwardData.quest.prizes.prizes;
    let formattedPrizes = prizes.map(prize => ({
      alt: prize.name,
      url: getCategoryLogo(prize.category)
    }));
    formattedPrizes = uniqBy(formattedPrizes, 'url');

    return (
      <div className="item-image-column">
        <img
          className="item-image"
          src={selectedItem.imageUrl || PurpleW}
          alt={selectedItem.name}
        />
        <ImageFadeComponent
          className="category-image"
          images={formattedPrizes}
        />
        {getLocationImage(selectedItem)}
      </div>
    );
  }

  truncateTitleText(title) {
    if (title.length > READ_TITLE_TEXT_TRIM) {
      return (
        <Fragment>
          <span aria-hidden="true">
            {title.substring(0, READ_TITLE_TEXT_TRIM).trim()}
            {'... '}
            <TextButton className="read-more" onClick={this.toggleOverlay}>
              (READ MORE)
            </TextButton>
          </span>
          <span className="sr-only">{title}</span>
        </Fragment>
      );
    } else {
      return title;
    }
  }

  getOverlayContent(text) {
    const className = `info-overlay ${this.state.showOverlay ? 'in' : 'out'}`;
    return (
      <div className={className} aria-hidden="true">
        <div className="close-overlay">
          <TextButton onClick={this.toggleOverlay}>
            <img src={CloseIcon} alt="Close overlay" />
          </TextButton>
        </div>
        <div className="overlay-content">{text}</div>
      </div>
    );
  }

  renderCompleteBy() {
    const { selectedItem } = this.props;

    return (
      <div className="complete-by">
        {`Complete by: ${selectedItem.claimEndDate}`}
      </div>
    );
  }

  renderTaskTracker(selectedItem) {
    const listOfMissions =
      selectedItem.prizeData.questAwardData.quest.achievements;

    return (
      <div className="task-tracker-container">
        {this.renderItemImage()}
        <div className="tasks">0 / {listOfMissions.length} Tasks Complete</div>
      </div>
    );
  }

  renderQuestDescriptionBox() {
    const { selectedItem } = this.props;

    return selectedItem.description.length < 150 ? (
      <div className="quest-item-description-container">
        <div className="item-description short-description">
          {selectedItem.description}
        </div>
      </div>
    ) : (
      <div className="quest-item-description-container">
        <div className="item-description">{selectedItem.description}</div>
      </div>
    );
  }

  renderMissionsContainer(selectedItem) {
    const missions = selectedItem.prizeData.questAwardData.quest.achievements;
    const missionList = missions.map((ach, index) => {
      return (
        <div key={index} className="mission">
          <div className="mission-title">
            <span className="mission-number">{index + 1}</span>
            {this.truncateTitleText(ach.description)}
          </div>
          <div className="mission-task"> {ach.progressPlaceholderText} </div>
          {this.getOverlayContent(ach.description)}
        </div>
      );
    });

    return <div className="quest-missions-container">{missionList}</div>;
  }

  renderRedeemButton() {
    const { selectedItem, onPurchase } = this.props;

    if (
      !isQuestActive(selectedItem) &&
      getQuestStockCount(selectedItem) > 0 &&
      !this.state.closeConfirmation
    ) {
      return (
        <BtnWithSounds
          className="btn-redeem"
          variant="orange"
          onClick={onPurchase}
        >
          Redeem & <br /> Start Quest
        </BtnWithSounds>
      );
    } else {
      return (
        <BtnWithSounds className="btn-redeem-disabled" variant="custom">
          Redeem & <br /> Start Quest
        </BtnWithSounds>
      );
    }
  }

  renderLeaderboardButton() {
    const { selectedItem } = this.props;
    const quest = selectedItem.prizeData.questAwardData.quest;
    if (quest.leaderboardEnabled) {
      return (
        <QuestLeaderboardButton
          quest={quest}
          claimEndDate={selectedItem.claimEndDate}
        />
      );
    } else {
      return null;
    }
  }

  render() {
    const { selectedItem, hidden, onClose, purchaseConfirmation } = this.props;
    const show = selectedItem && !hidden;
    const modalOverlay = purchaseConfirmation && !this.state.closeConfirmation;
    return (
      show && (
        <Modal
          className={`modal-dialog-wstore-quest ${
            modalOverlay ? 'modal-overlay' : ''
          }`}
          show={true}
          onHide={onClose}
        >
          <Modal.Body className="wstore-item-Quest">
            <div className="title-container">
              <div className="title">{selectedItem.name}</div>
              <button
                className="exit-modal-button"
                type="button"
                onClick={onClose}
              >
                <img src={ExitButtonIcon} alt="Close quest modal" />
              </button>
            </div>
            {this.renderCompleteBy()}
            {this.renderTaskTracker(selectedItem)}
            {this.renderQuestDescriptionBox()}
            {this.renderMissionsContainer(selectedItem)}
            <div className="modal-footer">
              <div className="wscore-quantity-container">
                <div className="wscore-info">
                  <WStoreGems item={selectedItem} />
                </div>
              </div>
              <div className="footer-buttons">{this.renderRedeemButton()}</div>
            </div>
            {modalOverlay && (
              <WStoreConfirmation
                isQuestItem={true}
                closeConfirmationPage={this.closeConfirmationPage}
                {...this.props}
              />
            )}
          </Modal.Body>
        </Modal>
      )
    );
  }
}

WStoreQuestModal.propTypes = {
  selectedItem: PropTypes.object,
  userWScore: PropTypes.number,
  onPurchase: PropTypes.func,
  purchaseRequested: PropTypes.bool,
  purchaseConfirmation: PropTypes.bool,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string,
  hidden: PropTypes.bool,
  onClose: PropTypes.func
};

export default WStoreQuestModal;
